import {AssertUtils} from "goingutils";

let ValidationUtils = {
    //设置对象属性值
    setPropValue(itemObj, propName, propValue) {
        if(itemObj==null){
            return void(0);
        }
        if (itemObj[propName] != null) {
            itemObj[propName] = propValue;
        } else {
            this.vueObj.$set(itemObj, propName, propValue);
        }
    },
    //清空错误信息
    clearError(itemObj) {
        this.setPropValue(itemObj, 'hasError', false);
        this.setPropValue(itemObj, 'validMsg', '');
    },
    _validateMaxNumber({itemObj, itemVal, validation,maxVal,msg}) {
        //校验最大值
        if (AssertUtils.isNotNull(maxVal)) {
            if (itemVal > maxVal) {
                this.setPropValue(itemObj, 'validMsg', msg?msg:'输入值应该小于了最大值' + maxVal);
                this.setPropValue(itemObj, 'hasError', true);
                validation.hasError = true;
            } else {
                this.clearError(itemObj);
                validation.hasError = false;
            }
        }
    },
    //校验最小值
    _validateMinNumber({itemObj, itemVal, validation,minVal,msg}) {
        //校验最小值
        if (AssertUtils.isNotNull(minVal)) {
            if (itemVal < minVal) {
                this.setPropValue(itemObj, 'validMsg', msg?msg:'输入值不能小于最小值' + minVal);
                this.setPropValue(itemObj, 'hasError', true);
                validation.hasError = true;
            } else {
                this.clearError(itemObj);
                validation.hasError = false;
            }
        }
    },
    //校验最大值
    _validateNumber(itemObj, itemVal, validation) {
        if(AssertUtils.isNumber(itemVal)){
            validation.hasError = false;
        }else{
            this.setPropValue(itemObj, 'validMsg', '请输入数字！');
            this.setPropValue(itemObj, 'hasError', true);
            validation.hasError = true;
        }
    },
    //最大长度校验
    _maxLengthValidation({itemObj, itemVal, validation,maxLength,msg}) {
        //校验是否为空
        if (AssertUtils.isNotNull(maxLength) && AssertUtils.isNotEmpty(itemVal)) {
            if (itemVal.length > maxLength) {
                this.setPropValue(itemObj, 'validMsg', msg?msg:'输入值的长度大于了最大长度' + maxLength + '位！');
                this.setPropValue(itemObj, 'hasError', true);
                validation.hasError = true;
            } else {
                this.clearError(itemObj);
                validation.hasError = false;
            }
        }
    },
    //必输校验
    _requiredValidation({itemObj, itemValue, validation,validateItem}) {
        //如果值为空
        if(!AssertUtils.isNotEmpty(itemValue)){
            itemValue=itemObj.defVal;
        }
        //校验是否为空
        if (!AssertUtils.isNotEmpty(itemValue)&&itemValue!==0) {
            this.setPropValue(itemObj, 'validMsg', AssertUtils.isNotEmpty(validateItem["msg"])?validateItem["msg"]:`${itemObj['label']}不能为空`);
            this.setPropValue(itemObj, 'hasError', true);
            validation.hasError = true;
        } else {
            this.clearError(itemObj);
            validation.hasError = false;
        }
    },
    //获取对象
    getItemObj(id, parentId) {
        if (!AssertUtils.isNotEmpty(parentId)) {
            return $(`input[itemId='${id}']`).get(0) || $(`textarea[itemId='${id}']`).get(0);
        } else {
            if (AssertUtils.isObject(parentId)) {
                return $(parentId.$el).find(`input[itemid='${id}']`).get(0) || $(`textarea[itemId='${id}']`).get(0);
            } else {
                return $('#' + parentId).find(`input[itemid='${id}']`).get(0) || $(`textarea[itemId='${id}']`).get(0);
            }
        }
    },
    //如果是隐藏元素
    isHiddenEl(itemEl) {
        if ($(itemEl).css('display') === 'none') {
            let ctlType=$(itemEl).attr("ctlType");
            //需要排除 授权类型的输入
            if(ctlType==="aclWin"){
                return false;
            }
            return true;
        }
        return false;
    },
    //根据id获取相应对象
    getItemObjById(domainObj, domainId) {
        let domainObjItem = null;
        for (let propName in domainObj) {
            if (propName === domainId) {
                domainObjItem = domainObj[propName];
                break;
            }
        }
        return domainObjItem;
    },
    //校验字符是否为中文
    validateIsCh({domainObj, fieldId, itemValue, vueObj}) {
        if (AssertUtils.isNotNull(vueObj)) {
            this.vueObj = vueObj;
        }
        let validation = {hasError: false};
        //校验字符是否为中文
        let pattern = /^[\u0391-\uFFE5]+$/;
        ValidationUtils._validateByEl(this.getItemObjById(domainObj, fieldId), itemValue, validation, pattern, '不是有效的中文!');
        //如果存在必输错误信息
        return !validation.hasError;
    },
    //校验座机电话号码
    validateTel({domainObj, fieldId, itemValue, vueObj}) {
        if (AssertUtils.isNotNull(vueObj)) {
            this.vueObj = vueObj;
        }
        //校验座机电话号码
        let validation = {hasError: false};
        var pattern = /^((\(\d{3}\))|(\d{3}\-))?(\(0\d{2,3}\)|0\d{2,3}-)?[1-9]\d{6,7}$/;
        ValidationUtils._validateByEl(this.getItemObjById(domainObj, fieldId), itemValue, validation, pattern, '不是有效的电话号码!');
        //如果不是有效的座机号码 则校验是否是移动电话号码
        if (validation.hasError) {
            return ValidationUtils.validateMobile({domainObj, fieldId, itemValue, vueObj, mssage: '不是有效的电话号码!'});
        }
        //如果存在必输错误信息
        return !validation.hasError;
    },
    //校验移动电话号码
    validateMobile({itemObj = null, domainObj, fieldId, itemValue, vueObj, mssage = '不是有效的移动电话号码!'}) {
        if (AssertUtils.isNotNull(vueObj)) {
            this.vueObj = vueObj;
        }
        let validation = {hasError: false};
        //校验移动电话号码
        let pattern = /^(((13[0-9]{1})|(17[0-9]{1})|(15[0-9]{1})|(18[0-9]{1}))+\d{8})$/;
        ValidationUtils._validateByEl(itemObj || this.getItemObjById(domainObj, fieldId), itemValue, validation, pattern, mssage);
        //如果存在必输错误信息
        return !validation.hasError;
    },
    //通过el表达式进行校验
    _validateByEl(itemObj, itemVal, validation, pattern, message) {
        //校验是否为空
        if (AssertUtils.isNotEmpty(itemVal) && !pattern.test(itemVal)) {
            this.setPropValue(itemObj, 'validMsg', message);
            this.setPropValue(itemObj, 'hasError', true);
            validation.hasError = true;
        } else {
            this.clearError(itemObj);
            validation.hasError = false;
        }
    },
    //校验邮箱地址
    validateMail({itemObj=null,domainObj, fieldId, itemValue, vueObj}) {
        if (AssertUtils.isNotNull(vueObj)) {
            this.vueObj = vueObj;
        }
        let validation = {hasError: false};
        //校验邮箱地址
        let pattern = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(\.[a-zA-Z0-9_-])+/;
        ValidationUtils._validateByEl(itemObj || this.getItemObjById(domainObj, fieldId), itemValue, validation, pattern, '不是有效的邮件地址!');
    },
    //校验邮政编码
    validationZip({itemObj=null,domainObj, fieldId, itemValue, vueObj}) {
        if (AssertUtils.isNotNull(vueObj)) {
            this.vueObj = vueObj;
        }
        let validation = {hasError: false};
        var pattern = /^[1-9]\d{5}$/;
        ValidationUtils._validateByEl(itemObj || this.getItemObjById(domainObj, fieldId), itemValue, validation, pattern, '不是有效的邮政编码!');
        //如果存在必输错误信息
        return !validation.hasError;
    },
    validateItemByType(validate, itemObj, itemValue, vueObj) {
        if (AssertUtils.isNotNull(vueObj)) {
            this.vueObj = vueObj;
        }
        //如果没有定义校验类型 而 item对象里面定义了校验类型
        if (!AssertUtils.isNotEmpty(validate)&&itemObj["validate"] != null) {
            validate = itemObj["validate"];
        }
        //如果传入的validate 为required|maxLength|minLength类型的校验字符串
        //如果传入的是数组 [{type:'required',msg:''},{type:'customer',fun:'',msg:''}]

        let validateAry=[];
        if(typeof(validate)==='string'){
            validate.split("|").forEach((typeName)=>{
                validateAry.push({type:typeName});
            });
        }else{
            //如果不是数组
            if(!AssertUtils.isArray(validate)){
                validateAry.push(validate);
            }else{
                validateAry=validate;
            }
        }
        //获取已定义对校验规则名称  为了不进行重复添加
        let valTypeNames=[];
        validateAry.forEach(function (validateItem) {
            valTypeNames.push(validateItem["type"]);
        });

        let valTypeNamesStr=valTypeNames.join(";");
        //如果没有定义长度校验 而对象中存在长度校验
        if ((valTypeNamesStr+"").indexOf("maxLength")<0) {
            if (itemObj["maxLength"]) {
                validateAry.unshift({type:"maxLength"});
            }
        }

        //如果没有定义必输校验 而对象中存在必输参数 则判断是否需要校验必输
        if ((valTypeNamesStr+"").indexOf("required")<0) {
            if (itemObj.required) {
                validateAry.unshift({type:"required"});
            }
        }

        let validation = {hasError: false};
        //如果存在校验类型
        if (AssertUtils.isArray(validateAry)) {
            //倒叙后 再进行循环
            validateAry.forEach(function (validateItem) {
                let validateType=validateItem&&validateItem.type;
                switch (validateType) {
                    case "required":
                        if (!validation.hasError) {
                            //必输校验
                            ValidationUtils._requiredValidation({itemObj, itemValue, validation,validateItem});
                        }
                        break;
                    case "mobile":
                        if (!validation.hasError) {
                            //移动电话校验
                            ValidationUtils.validateMobile({itemObj, itemValue, vueObj});
                        }
                        break;
                    case "mail":
                        if (!validation.hasError) {
                            //是否为邮件
                            ValidationUtils.validateMail({itemObj, itemValue, vueObj,validateItem});
                        }
                        break;
                    case "ch":
                        if (!validation.hasError) {
                            //是否为中文
                            ValidationUtils.validateIsCh({itemObj, itemValue, vueObj});
                        }
                        break;
                    case "phone":
                        if (!validation.hasError) {
                            //校验电话号码
                            ValidationUtils.validateTel({itemObj, itemValue, vueObj});
                        }
                        break;
                    case "zipCode":
                        if (!validation.hasError) {
                            //校验电话号码
                            ValidationUtils.validationZip({itemObj, itemValue, vueObj,validateItem});
                        }
                        break;
                    case "maxLength":
                        if (!validation.hasError) {
                            //长度校验
                            ValidationUtils._maxLengthValidation({itemObj, itemValue, validation,vueObj,maxLength:validateItem["val"],msg:validateItem["msg"]});
                        }
                        break;
                    case "min":
                        if (!validation.hasError) {
                            //只有输入对是数字才需要这样校验
                            if(AssertUtils.isNumber(itemValue)){
                                //最小值校验
                                //校验最小值
                                ValidationUtils._validateMinNumber({itemObj, itemValue, validation,minVal:validateItem["val"],msg:validateItem["msg"]});
                            }
                        }
                        break;
                    case "max":
                        if (!validation.hasError) {
                            //只有输入对是数字才需要这样校验
                            if(AssertUtils.isNumber(itemValue)){
                                //校验最大值
                                ValidationUtils._validateMaxNumber({itemObj, itemValue, validation,maxVal:validateItem["val"],msg:validateItem["msg"]});
                            }
                        }
                        break;
                    case "custom":
                        if (!validation.hasError) {
                            vueObj.setPropValue(itemObj, 'validMsg', "");
                            vueObj.setPropValue(itemObj, 'hasError', false);
                            vueObj.$emit('validaeFun',{itemObj, itemValue});
                        }
                        break;
                }
            });
        }
        return validation;
    },
    //单个元素校验
    validationItem(itemObj, itemValue, vueObj) {
        if (AssertUtils.isNotNull(vueObj)) {
            this.vueObj = vueObj;
        }
        let validation=this.validateItemByType('', itemObj, itemValue, vueObj);
        //如果存在必输错误信息
        return validation;
    },
    //如果存在错误提醒
    hasWarningEl(domainObj, parentId) {
        if(!AssertUtils.isNotEmpty(parentId)){
            parentId="main_router_view";
        }
        let parentEl = null;
        let showFlag = false;
        if (AssertUtils.isObject(parentId)) {
            parentEl = $(parentId.$el).get(0);
        } else {
            parentEl = $("#" + parentId).get(0);
        }
        //查找已经存在错误的元素
        $(parentEl).find(".ivu-icon-md-warning").each(function (index, item) {
            //如果不是隐藏元素
            if (!ValidationUtils.isHiddenEl(item) && showFlag === false) {
                showFlag = true;
            }
        });
        return showFlag;
    },
    //数字校验
    validationNumberItem(itemObj, itemValue, vueObj) {
        if (AssertUtils.isNotNull(vueObj)) {
            this.vueObj = vueObj;
        }
        let validation = {hasError: false};
        //校验数字类型
        ValidationUtils._validateNumber(itemObj, itemValue, validation);
        if (!validation.hasError&&AssertUtils.isNotNull(itemObj['min'])) {
            //校验最小值
            ValidationUtils._validateMinNumber(itemObj, itemValue, validation,itemObj['min']);
        }
        if (!validation.hasError&&AssertUtils.isNotNull(itemObj['max'])) {
            //校验最大值
            ValidationUtils._validateMaxNumber(itemObj, itemValue, validation,itemObj['max']);
        }
    },
    //校验数据
    validationDatas({domainObj, domainData, parentId, vueObj}) {
        this.vueObj = vueObj;
        //如果存在parentId 则判断是否已经存在错误提醒元素 如果存在则直接返回
        let flag = this.hasWarningEl(domainObj, parentId);
        if (flag) {
            return false;
        }

        let validateFlag = true;
        for (let propName in domainObj) {
            let domainObjItem = domainObj[propName];
            let {id} = domainObjItem;
            if (AssertUtils.isNotEmpty(id)) {
                let itemEl = this.getItemObj(id, parentId);
                if (itemEl != null) {
                    //如果不是隐藏元素 才需要校验
                    let hideFlag = this.isHiddenEl(itemEl);
                    if (!hideFlag) {
                        let {hasError} = this.validationItem(domainObjItem, domainData[id]);
                        if (hasError) {
                            validateFlag = false;
                        }
                    }
                }
            }

        }
        return validateFlag;
    }
};
export default ValidationUtils;



// WEBPACK FOOTER //
// ./goingsrc/mixins/ValidationUtils.js